import React, { useEffect } from "react";
import {
  fetchAllExams,
  fetchStaffList,
} from "../../store/slices/contentFeedback/contentFeedbackSlice";
import { useAppDispatch } from "../../hooks/storeHooks";
import ContentFeedback from "./ContentFeedback";

function CfContainer() {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(fetchStaffList());
    dispatch(fetchAllExams());
  }, [dispatch]);
  return <ContentFeedback />;
}

export default CfContainer;
